// extracted by mini-css-extract-plugin
export default {"footer":"Landing_footer__WWOXI","gg":"Landing_gg__c+Txx"};